import { render, staticRenderFns } from "./ProductModel-Column-Three.vue?vue&type=template&id=2c464075&"
import script from "./ProductModel-Column-Three.vue?vue&type=script&lang=js&"
export * from "./ProductModel-Column-Three.vue?vue&type=script&lang=js&"
import style0 from "./ProductModel-Column-Three.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports